var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zidingyi_shiping",style:(_vm.shu.yangshi)},[(_vm.shu.shu)?_c('el-image',{style:(_vm.yangshi),attrs:{"src":_vm.shu.shu.tu}}):_vm._e(),_c('div',{staticClass:"el-icon-caret-left bofan",style:(_vm.yangshis)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }